import React from 'react'

export default function Footer() {
  return (
    <div className="App-footer">
      <div>Designed and developed by Jacky C. Yang</div>
      <div>Data from Studio Ghibli API, OMDb API, and IMDb API</div>
      <div>Home page image by: hyung86 on experiencefilm.com</div>
    </div>
  )
}
